import { render, staticRenderFns } from "./IcoLanguage.vue?vue&type=template&id=b2fc8b50"
import script from "./IcoLanguage.vue?vue&type=script&lang=js"
export * from "./IcoLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports